module.exports = __webpack_public_path__ + "img/menu-icon-4-3.c304c76d.svg";